import Dialog from './Dialog.styled';

export { DIALOG_ANIMATION_DURATION_MS } from './Dialog';
export { default as DialogTitle } from './DialogTitle.styled';
export { default as DialogContent } from './DialogContent.styled';
export { default as DialogActions } from './DialogActions.styled';
export { default as AlertDialog } from './AlertDialog';

export default Dialog;
